/**
 * BottomQuickActions - Shared quick action buttons for page footers
 * 
 * Displays a row of 4 action buttons: Add Customer, Create Job, New Estimate, Create Invoice
 * Used across Dashboard, Customers, Jobs, Followups, Calendar, Estimates, and Invoices pages
 * 
 * Mobile hardening: Respects iOS safe area insets and has proper tap targets
 * 
 * Auto-open modals: Uses ?new=1 query param to trigger create modal on destination page
 */

import { Link } from "react-router-dom";
import { Card, CardContent } from "./ui/card";
import { Plus, Briefcase, FileText, Receipt } from "phosphor-react";

export default function BottomQuickActions() {
  return (
    <div 
      className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mt-6 pb-[max(1rem,env(safe-area-inset-bottom))]" 
      data-testid="bottom-quick-actions"
    >
      <Link to="/customers?new=1" className="touch-manipulation" data-testid="quick-add-customer">
        <Card className="border-2 border-zinc-200 card-hover cursor-pointer active:scale-[0.98] transition-transform">
          <CardContent className="p-3 sm:p-4 text-center min-h-[72px] flex flex-col items-center justify-center">
            <Plus size={24} className="mx-auto mb-1 sm:mb-2 text-[#FF6600]" />
            <p className="text-xs sm:text-sm font-medium">Add Customer</p>
          </CardContent>
        </Card>
      </Link>
      <Link to="/jobs?new=1" className="touch-manipulation" data-testid="quick-create-job">
        <Card className="border-2 border-zinc-200 card-hover cursor-pointer active:scale-[0.98] transition-transform">
          <CardContent className="p-3 sm:p-4 text-center min-h-[72px] flex flex-col items-center justify-center">
            <Briefcase size={24} className="mx-auto mb-1 sm:mb-2 text-[#FF6600]" />
            <p className="text-xs sm:text-sm font-medium">Create Job</p>
          </CardContent>
        </Card>
      </Link>
      <Link to="/estimates?new=1" className="touch-manipulation" data-testid="quick-new-estimate">
        <Card className="border-2 border-zinc-200 card-hover cursor-pointer active:scale-[0.98] transition-transform">
          <CardContent className="p-3 sm:p-4 text-center min-h-[72px] flex flex-col items-center justify-center">
            <FileText size={24} className="mx-auto mb-1 sm:mb-2 text-[#FF6600]" />
            <p className="text-xs sm:text-sm font-medium">New Estimate</p>
          </CardContent>
        </Card>
      </Link>
      <Link to="/invoices?new=1" className="touch-manipulation" data-testid="quick-create-invoice">
        <Card className="border-2 border-zinc-200 card-hover cursor-pointer active:scale-[0.98] transition-transform">
          <CardContent className="p-3 sm:p-4 text-center min-h-[72px] flex flex-col items-center justify-center">
            <Receipt size={24} className="mx-auto mb-1 sm:mb-2 text-[#FF6600]" />
            <p className="text-xs sm:text-sm font-medium">Create Invoice</p>
          </CardContent>
        </Card>
      </Link>
    </div>
  );
}
